import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  AfterViewInit,
  ViewChild,
  ElementRef,
  HostListener,
  OnInit,
  Inject,
  PLATFORM_ID,
} from '@angular/core';

@Component({
  selector: 'app-canvas-infographic',
  templateUrl: './canvas-infographic.component.html',
  styleUrls: ['./canvas-infographic.component.scss'],
  standalone: true,
  imports: [],
})
export class CanvasInfographicComponent implements OnInit, AfterViewInit {
  @ViewChild('infographicCanvas') canvasRef!: ElementRef<HTMLCanvasElement>;
  private ctx!: CanvasRenderingContext2D;
  image!: HTMLImageElement;
  private isMobile = false;
  private lastHoveredMarker: any = null;

  // Zoom & Pan
  private zoom = 1;
  private offsetX = 0;
  private offsetY = 0;

  // Markers Desktop
  private elements = [
    //  left side
    {
      text: 'Raised collar for \nsling protection',
      markerX: 817,
      markerY: 67,
      textX: 270,
      textY: 67,
    },
    // { text: "IDEAL Zippers & Pulls", markerX: 684, markerY: 154, textX: 270, textY: 154 },
    {
      text: 'Breathable, \nquick-dry material',
      markerX: 840,
      markerY: 229,
      textX: 270,
      textY: 229,
    },
    {
      text: 'Athletic performance fit',
      markerX: 684,
      markerY: 315,
      textX: 270,
      textY: 315,
    },
    {
      text: 'Adjustable hook-and-loop \nwaist tab',
      markerX: 798,
      markerY: 400,
      textX: 270,
      textY: 400,
    },
    {
      text: 'Drain holes in pockets',
      markerX: 783,
      markerY: 639,
      textX: 270,
      textY: 639,
    },
    // right side
    {
      text: `Shallow V-neck`,
      markerX: 892,
      markerY: 93,
      textX: 1300,
      textY: 93,
    },
    {
      text: `Soft loop fastener`,
      markerX: 1060,
      markerY: 172,
      textX: 1300,
      textY: 172,
    },
    // { text: "100% 🇺🇸\nMade in the USA\nFabrics", markerX: 932, markerY: 308, textX: 1300, textY: 308 },
    {
      text: 'Athletic performance fit',
      markerX: 932,
      markerY: 308,
      textX: 1300,
      textY: 308,
    },
    {
      text: 'Oversized belt loops',
      markerX: 1000,
      markerY: 440,
      textX: 1300,
      textY: 440,
    },
    {
      text: 'Ballistic nylon \nreinforced knees',
      markerX: 979,
      markerY: 792,
      textX: 1300,
      textY: 792,
    },
    {
      text: 'IDEAL Zippers & Pulls',
      markerX: 886,
      markerY: 570,
      textX: 1300,
      textY: 570,
    },
    // { text: "Durable, lightweight, wind and \nwater-resistant fabric", markerX: 1009, markerY: 929, textX: 1424, textY: 929 },
  ];
  private mobileElements = [
    {
      text: 'Raised collar for \nsling protection',
      markerX: 188,
      markerY: 90,
      textX: 270,
      textY: 67,
    },
    {
      text: 'Breathable, \nquick-dry material',
      markerX: 213,
      markerY: 210,
      textX: 270,
      textY: 229,
    },
    {
      text: 'Athletic performance fit',
      markerX: 126,
      markerY: 289,
      textX: 270,
      textY: 315,
    },
    {
      text: 'Adjustable hook-and-loop \nwaist tab',
      markerX: 180,
      markerY: 358,
      textX: 270,
      textY: 400,
    },
    {
      text: 'Drain holes in pockets',
      markerX: 168,
      markerY: 547,
      textX: 270,
      textY: 639,
    },
    // right side
    {
      text: `Shallow V-neck`,
      markerX: 272,
      markerY: 115,
      textX: 1300,
      textY: 93,
    },
    {
      text: `Soft loop fastener`,
      markerX: 384,
      markerY: 189,
      textX: 1300,
      textY: 172,
    },
    // {
    //   text: 'Athletic \nperformance fit',
    //   markerX: 274,
    //   markerY: 295,
    //   textX: 1300,
    //   textY: 308,
    // },
    {
      text: 'Oversized belt loops',
      markerX: 319,
      markerY: 393,
      textX: 1300,
      textY: 440,
    },
    {
      text: 'Ballistic nylon \nreinforced knees',
      markerX: 322,
      markerY: 651,
      textX: 1300,
      textY: 792,
    },
    {
      text: 'IDEAL Zippers & Pulls',
      markerX: 235,
      markerY: 486,
      textX: 1300,
      textY: 570,
    },
  ];

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit() {}
  ngAfterViewInit() {
    try {
      if (isPlatformBrowser(this.platformId)) {
        this.image = new Image();
        this.ctx = this.canvasRef.nativeElement.getContext('2d')!;
        this.checkViewportSize();
        this.image.onload = () => this.drawInfographic();
      }
    } catch (error) {
      console.error('Error initializing Image:', error);
    }
  }

  initCanvas() {
    this.ctx = this.canvasRef.nativeElement.getContext('2d')!;
    this.checkViewportSize();
    this.image.onload = () => this.drawInfographic();

    // this.canvasRef.nativeElement.addEventListener("mousemove", (event) => this.onCanvasHover(event));
    // this.canvasRef.nativeElement.addEventListener("touchstart", (event) => this.onCanvasTouch(event));
  }

  private imageX = 0;
  private imageY = 0;
  private imageWidth = 1016;
  private imageHeight = 1152;

  private checkViewportSize() {
    this.isMobile = window.innerWidth < 1025;

    if (this.isMobile) {
      this.image.src =
        'https://cdn.shopify.com/s/files/1/0003/4183/5782/files/Full_uniform_set-cropped.png?v=1738963362';
      // this.image.src = "https://cdn.shopify.com/s/files/1/0003/4183/5782/files/Full_uniform_set-m.png?v=1742833336";
      this.canvasRef.nativeElement.width = 500;
      this.canvasRef.nativeElement.height = 1024;

      // Mobile image positioning
      this.imageX = 46;
      this.imageY = 0;
      this.imageWidth = 402;
      this.imageHeight = 1000;
    } else {
      this.image.src =
        'https://cdn.shopify.com/s/files/1/0003/4183/5782/files/Full_uniform_set.png?v=1738880974';
      this.canvasRef.nativeElement.width = 1728;
      this.canvasRef.nativeElement.height = 1200;

      // Desktop image positioning
      this.imageX = 346;
      this.imageY = 0;
      this.imageWidth = 1016;
      this.imageHeight = 1152;
    }
  }

  private drawInfographic() {
    const canvas = this.canvasRef.nativeElement;
    this.ctx.clearRect(0, 0, canvas.width, canvas.height);

    this.ctx.save();
    this.ctx.translate(this.offsetX, this.offsetY);
    // this.ctx.scale(this.zoom, this.zoom);

    // ✅ Use dynamic image position and dimensions
    this.ctx.drawImage(
      this.image,
      this.imageX,
      this.imageY,
      this.imageWidth,
      this.imageHeight
    );
    this.isMobile = window.innerWidth < 1025;
    const els = this.isMobile ? this.mobileElements : this.elements;
    els.forEach(({ text, markerX, markerY, textX, textY }) => {
      this.drawMarker(markerX, markerY);
      if (!this.isMobile) {
        const textWidth = this.drawText(text, textX, textY);
        const isLeftSide = markerX < canvas.width / 2;
        const lineEndX = isLeftSide ? textX + textWidth + 10 : textX - 10;
        this.drawLine(markerX, markerY, lineEndX, textY - 4);
      }
    });

    this.ctx.restore();
  }

  private drawMarker(x: number, y: number) {
    if (this.isMobile) {
      this.ctx.save();
      this.ctx.translate(x, y);
      this.ctx.rotate(Math.PI / 4);
      this.ctx.fillStyle = '#D5CAB1';
      this.ctx.fillRect(-6, -6, 12, 12);
      this.ctx.strokeStyle = '#D5CAB1';
      this.ctx.lineWidth = 2;
      this.ctx.strokeRect(-12, -12, 24, 24);
      this.ctx.restore();
    } else {
      this.ctx.save();
      this.ctx.translate(x, y);
      this.ctx.rotate(Math.PI / 4);
      this.ctx.fillStyle = '#D5CAB1';
      this.ctx.fillRect(-5, -5, 10, 10);
      this.ctx.strokeStyle = '#D5CAB1';
      this.ctx.lineWidth = 2;
      this.ctx.strokeRect(-8, -8, 16, 16);
      this.ctx.restore();
    }
  }

  private drawLine(x1: number, y1: number, x2: number, y2: number) {
    this.ctx.beginPath();
    this.ctx.moveTo(x1, y1);
    this.ctx.lineTo(x2, y2);
    this.ctx.strokeStyle = '#D5CAB1';
    this.ctx.lineWidth = 1;
    this.ctx.stroke();
  }

  private drawText(text: string, x: number, y: number): number {
    this.ctx.font = '21px Industry, sans-serif';
    this.ctx.fillStyle = '#D5CAB1';
    const lines = text.split('\n');
    let maxWidth = 0;
    lines.forEach((line, index) => {
      const textWidth = this.ctx.measureText(line).width;
      maxWidth = Math.max(maxWidth, textWidth);
      this.ctx.fillText(line, x, y + index * 24);
    });
    return maxWidth;
  }

  // private onCanvasHover(event: MouseEvent) {
  //   const canvas = this.canvasRef.nativeElement;
  //   const rect = canvas.getBoundingClientRect();
  //   const x = event.clientX - rect.left;
  //   const y = event.clientY - rect.top;

  //   let hoveredMarker = null;

  //   this.elements.forEach(({ markerX, markerY, text }) => {
  //     if (Math.sqrt((x - markerX) ** 2 + (y - markerY) ** 2) < 20) {
  //       hoveredMarker = { text, x, y };
  //     }
  //   });

  //   if (JSON.stringify(hoveredMarker) !== JSON.stringify(this.lastHoveredMarker)) {
  //     this.lastHoveredMarker = hoveredMarker;
  //     this.drawInfographic();
  //     if (hoveredMarker) {
  //       this.drawTooltip(hoveredMarker);
  //     }
  //   }
  // }

  // private onCanvasTouch(event: TouchEvent) {
  //   // event.preventDefault();
  //   console.log('Touch event:', event);
  //   const canvas = this.canvasRef.nativeElement;
  //   const rect = canvas.getBoundingClientRect();
  //   const touch = event.touches[0];
  //   const x = touch.clientX - rect.left;
  //   const y = touch.clientY - rect.top;

  //   this.mobileElements.forEach(({ markerX, markerY, text }) => {
  //     if (Math.sqrt((x - markerX) ** 2 + (y - markerY) ** 2) < 20) {
  //       this.drawInfographic();
  //       this.drawTooltip({ text, x, y });
  //     }
  //   });
  // }
  resizeTimer: any = null;
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
    this.resizeTimer = setTimeout(() => {
      this.checkViewportSize();
      this.drawInfographic();
    }, 100);
  }

  @HostListener('touchstart', ['$event'])
  private onCanvasTouch(event: TouchEvent) {
    const canvas = this.canvasRef.nativeElement;
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;

    const touch = event.touches[0];
    const x = (touch.clientX - rect.left) * scaleX;
    const y = (touch.clientY - rect.top) * scaleY;

    let newTooltip: any = null;

    this.mobileElements.forEach(({ markerX, markerY, text }) => {
      if (Math.sqrt((x - markerX) ** 2 + (y - markerY) ** 2) < 16) {
        newTooltip = { text, x, y };
        return; // Exit function after finding the first matching marker
      }
    });

    if (newTooltip) {
      // Clear the current tooltip if it exists
      if (this.currentTooltip) {
        if (this.tooltipTimeoutId) {
          clearTimeout(this.tooltipTimeoutId);
          this.tooltipTimeoutId = null;
        }
        this.currentTooltip = null;
      }

      // Draw the new tooltip
      this.drawInfographic();

      setTimeout(() => {
        this.drawTooltip(newTooltip);
      }, 1);

      this.drawTooltip(newTooltip);
    } else if (this.currentTooltip) {
      // Clear the tooltip if clicking outside any marker
      if (this.tooltipTimeoutId) {
        clearTimeout(this.tooltipTimeoutId);
        this.tooltipTimeoutId = null;
      }
      this.currentTooltip = null;
      this.drawInfographic();
    }
  }

  private currentTooltip: { text: string; x: number; y: number } | null = null;
  private tooltipTimeoutId: any = null;

  private drawTooltip({ text, x, y }: any) {
    this.ctx.font = '18px Industry, sans-serif';
    const padding = 10;
    const lines = text.split('\n');
    const lineHeight = 22;

    // Measure maximum text width
    let maxWidth = 0;
    lines.forEach((line: string) => {
      const width = this.ctx.measureText(line).width;
      maxWidth = Math.max(maxWidth, width);
    });

    // Calculate tooltip dimensions
    const tooltipWidth = maxWidth + padding * 2;
    const tooltipHeight = lines.length * lineHeight + padding * 2;

    // Get canvas width for bounds checking
    const canvas = this.canvasRef.nativeElement;
    const canvasWidth = canvas.width;

    // Calculate initial tooltip position relative to marker
    let tooltipX = x + 10;
    const tooltipY = y - tooltipHeight - 10;

    // If tooltip would flow off to the right, position it on the left
    if (tooltipX + tooltipWidth > canvasWidth) {
      tooltipX = x - tooltipWidth - 2;
      if (tooltipX < 0) {
        tooltipX = 0;
      }
    }

    // Draw tooltip background
    this.ctx.fillStyle = '#D5CAB1';
    this.ctx.fillRect(tooltipX, tooltipY, tooltipWidth, tooltipHeight);

    // Draw black outline
    this.ctx.strokeStyle = '#000000';
    this.ctx.lineWidth = 1;
    this.ctx.strokeRect(tooltipX, tooltipY, tooltipWidth, tooltipHeight);

    // Draw outer #D5CAB1 stroke
    this.ctx.strokeStyle = '#D5CAB1';
    this.ctx.lineWidth = 3;
    this.ctx.strokeRect(
      tooltipX - 2,
      tooltipY - 2,
      tooltipWidth + 4,
      tooltipHeight + 4
    );

    // Draw text inside tooltip
    this.ctx.fillStyle = '#171717';
    lines.forEach((line: string, i: number) => {
      const textY = tooltipY + padding + (i + 1) * lineHeight - 4;
      this.ctx.fillText(line, tooltipX + padding, textY);
    });

    this.ctx.save(); // Save the current context state
    // Draw circle behind the "x" close button
    const closeButtonSize = 22;
    const closeButtonX = tooltipX + tooltipWidth - closeButtonSize + 10;
    const closeButtonY = tooltipY - 10;
    const circleRadius = closeButtonSize / 2;

    this.ctx.beginPath();
    this.ctx.arc(
      closeButtonX + circleRadius,
      closeButtonY + circleRadius,
      circleRadius,
      0,
      2 * Math.PI
    );
    this.ctx.fillStyle = '#D5CAB1';
    this.ctx.fill();

    // Draw "x" for closing the tooltip
    this.ctx.fillStyle = '#171717';
    this.ctx.font = '16px sans-serif';
    this.ctx.textAlign = 'center';
    this.ctx.textBaseline = 'middle';
    this.ctx.fillText(
      'x',
      closeButtonX + circleRadius,
      closeButtonY + circleRadius
    );
    this.ctx.restore(); // Restore the context state to avoid affecting other text
    // this.ctx.fillText(
    //   'x',
    //   closeButtonX + circleRadius,
    //   closeButtonY + circleRadius
    // );

    // Store tooltip state and clear any previous timeout
    this.currentTooltip = { text, x, y };
    if (this.tooltipTimeoutId) {
      clearTimeout(this.tooltipTimeoutId);
    }
    // Clear tooltip after 8000ms
    this.tooltipTimeoutId = setTimeout(() => {
      this.currentTooltip = null;
      this.tooltipTimeoutId = null;
      this.drawInfographic();
    }, 8000);

    // Add click detection for the "X"
    canvas.addEventListener('click', (event: MouseEvent) => {
      const rect = canvas.getBoundingClientRect();
      const clickX = event.clientX - rect.left;
      const clickY = event.clientY - rect.top;

      if (
        clickX >= closeButtonX &&
        clickX <= closeButtonX + closeButtonSize &&
        clickY >= closeButtonY &&
        clickY <= closeButtonY + closeButtonSize
      ) {
        this.currentTooltip = null;
        if (this.tooltipTimeoutId) {
          clearTimeout(this.tooltipTimeoutId);
          this.tooltipTimeoutId = null;
        }
        this.drawInfographic();
      }
    });
  }

  // @HostListener('mousedown', ['$event'])
  // onCanvasClick(event: MouseEvent) {
  //   const canvas = this.canvasRef.nativeElement;
  //   const rect = canvas.getBoundingClientRect();
  //   const x = event.clientX - rect.left;
  //   const y = event.clientY - rect.top;

  //   console.log(`markerX: ${x}, markerY: ${y}`);
  //   this.mobileElements.forEach(({ markerX, markerY, text }) => {
  //     if (Math.sqrt((x - markerX) ** 2 + (y - markerY) ** 2) < 20) {
  //       this.drawInfographic();
  //       this.drawTooltip({ text, x, y });
  //     }
  //   });
  // }
}
